import React from 'react';

import { STAGE_VALUES } from '../common-util/resources';

const WizardContext = React.createContext({});

function withWizardContext(Component: any) {
    return (props: any) => {
        return (
            <WizardContext.Consumer>
                {ctx => <Component {...props} wizardContext={ctx} />}
            </WizardContext.Consumer>
        );
    };
}

export interface WizardContextData {
    portfolioId: string;
    importId: string;
    type: string;
    setStage: (stage: STAGE_VALUES) => void;
    fileName: string;
}

export interface WizardContextProps {
    wizardContext: WizardContextData;
}

export { WizardContext, withWizardContext };
